import styled from 'styled-components';

export default styled.div`
    .iframeContainer {
        padding-top: 20px;
        height: 85vh;
        max-height: 100vh;
    }
`;
